


export enum eCPXDEV_TYPE
{
  eCPXDEV_TYPE_FREE = 0,
  eCPXDEV_TYPE_EVHI_HP = 1,
  eCPXDEV_TYPE_EVHI_LP = 2,
  eCPXDEV_TYPE_TESTER = 99
}
